import { render, staticRenderFns } from "./MonthItemDb.vue?vue&type=template&id=2e4118aa"
import script from "./MonthItemDb.ts?vue&type=script&lang=ts&external"
export * from "./MonthItemDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports